module.exports = __webpack_public_path__ + "img/icon_3_16.7323417d.png";